import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsVirtualAgentSettingsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-virtual-agent',
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent',
	exact: true,
};
